import React, { useState, Children, Component } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import { MenuIcon, XIcon } from 'lucide-react';
const LegalNavbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navItems = [{
    name: 'Product',
    href: '/#product'
  }, {
    name: 'Components',
    href: '/#components'
  }, {
    name: 'Platform',
    href: '/#platform'
  }, {
    name: 'Security',
    href: '/#security'
  }, {
    name: 'Community',
    href: '/community'
  }, {
    name: 'Pricing',
    href: '/#pricing'
  }];
  return <header className="w-full bg-white/80 backdrop-blur-md sticky top-0 z-50 border-b border-gray-100" data-id="element-1371">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-1372">
        <div className="flex items-center gap-2" data-id="element-1373">
          <Link to="/" className="flex items-center group" data-id="element-1374">
            <img src="https://cdn.magicpatterns.com/uploads/fMJnv7yQ9EawQ6b54Tnvxq/FWLogo.png" alt="FluidWeb Logo" className="h-8 transition-opacity group-hover:opacity-80" data-id="element-1375" />
          </Link>
        </div>

        <nav className="hidden md:flex items-center space-x-8" data-id="element-1376">
          {navItems.map((item, index) => item.href.startsWith('/#') ? <a key={index} href={item.href} className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors" data-id="element-1377">
                {item.name}
              </a> : <Link key={index} to={item.href} className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors" data-id="element-1378">
                {item.name}
              </Link>)}

          <a href="https://cal.com/fluidn/30min" target="_blank" rel="noopener noreferrer" className="bg-gray-900 text-white px-5 py-2.5 rounded-full text-sm font-medium hover:bg-gray-800 transition-colors whitespace-nowrap" data-id="element-1379">
            Get a demo
          </a>
        </nav>

        <button className="md:hidden text-gray-700 p-2" onClick={() => setIsOpen(!isOpen)} data-id="element-1380">
          {isOpen ? <XIcon size={24} data-id="element-1381" /> : <MenuIcon size={24} data-id="element-1382" />}
        </button>
      </div>

      {isOpen && <div className="md:hidden bg-white border-b border-gray-100 absolute w-full left-0 top-full shadow-xl" data-id="element-1383">
          <div className="container mx-auto px-4 py-4 flex flex-col space-y-4" data-id="element-1384">
            {navItems.map((item, index) => item.href.startsWith('/#') ? <a key={index} href={item.href} className="text-gray-700 py-2 hover:text-orange-500 transition-colors font-medium" onClick={() => setIsOpen(false)} data-id="element-1385">
                  {item.name}
                </a> : <Link key={index} to={item.href} className="text-gray-700 py-2 hover:text-orange-500 transition-colors font-medium" onClick={() => setIsOpen(false)} data-id="element-1386">
                  {item.name}
                </Link>)}
            <div className="border-t border-gray-100 pt-4" data-id="element-1387">
              <a href="https://cal.com/fluidn/30min" target="_blank" rel="noopener noreferrer" className="bg-gray-900 text-white px-4 py-3 rounded-lg hover:bg-gray-800 transition-colors text-center font-medium block" data-id="element-1388">
                Get a demo
              </a>
            </div>
          </div>
        </div>}
    </header>;
};
const TermsOfUse = () => {
  return <div className="w-full min-h-screen font-sans" data-id="element-1389">
      <LegalNavbar data-id="element-1390" />
      <main className="container mx-auto px-4 py-12 max-w-4xl" data-id="element-1391">
        <h1 className="text-3xl font-bold mb-6" data-id="element-1392">
          FluidForm, Inc. — Terms of Service
        </h1>
        <p className="text-gray-600 mb-8" data-id="element-1393">Last Updated: 08/16/2025</p>
        <section className="mb-8" data-id="element-1394">
          <h2 className="text-xl font-semibold mb-4" data-id="element-1395">1. Introduction</h2>
          <p className="mb-4" data-id="element-1396">
            Welcome to FluidForm, Inc. ("FluidForm," "we," "us," or "our").
            These Terms of Service ("Terms") govern your access to and use of
            our products, services, websites, and applications (collectively,
            the "Services"). By accessing or using the Services, you agree to be
            bound by these Terms. If you do not agree, please do not use the
            Services.
          </p>
          <p className="mb-4" data-id="element-1397">
            Company Information:
            <br data-id="element-1398" />
            FluidForm, Inc.
            <br data-id="element-1399" />
            2261 Market Street STE 85091 San Francisco, CA 94114
            <br data-id="element-1400" />
            <a href="mailto:support@fluid-form.ai" className="text-blue-600 hover:underline" data-id="element-1401">
              support@fluid-form.ai
            </a>
          </p>
        </section>
        <section className="mb-8" data-id="element-1402">
          <h2 className="text-xl font-semibold mb-4" data-id="element-1403">
            2. Eligibility / Minimum Age
          </h2>
          <p className="mb-4" data-id="element-1404">
            You must be 13 years of age or older to use the Services.
            Individuals aged 13 through 17 may use the Services only with
            consent from a parent or legal guardian, who must accept these Terms
            on their behalf. Children under 13 are not permitted to use the
            Services.
          </p>
        </section>
        <section className="mb-8" data-id="element-1405">
          <h2 className="text-xl font-semibold mb-4" data-id="element-1406">
            3. Account Registration & Security
          </h2>
          <p className="mb-4" data-id="element-1407">
            To access certain features, you may need to create an account. You
            agree to:
          </p>
          <ul className="list-disc pl-8 mb-4" data-id="element-1408">
            <li className="mb-2" data-id="element-1409">
              Provide accurate, current, and complete information.
            </li>
            <li className="mb-2" data-id="element-1410">Safeguard your account credentials.</li>
            <li className="mb-2" data-id="element-1411">
              Notify us immediately if you suspect unauthorized account use.
            </li>
          </ul>
          <p className="mb-4" data-id="element-1412">
            You are responsible for all activities that occur under your
            account.
          </p>
        </section>
        <section className="mb-8" data-id="element-1413">
          <h2 className="text-xl font-semibold mb-4" data-id="element-1414">4. Acceptable Use</h2>
          <p className="mb-4" data-id="element-1415">
            You may use the Services only for lawful purposes and in accordance
            with these Terms. You agree not to:
          </p>
          <ul className="list-disc pl-8 mb-4" data-id="element-1416">
            <li className="mb-2" data-id="element-1417">
              Engage in deceptive, harassing, or illegal activity.
            </li>
            <li className="mb-2" data-id="element-1418">
              Interfere with or disrupt the Services (e.g., using bots,
              scraping, reverse engineering).
            </li>
            <li className="mb-2" data-id="element-1419">
              Misuse or exploit features of the Services in unintended ways.
            </li>
          </ul>
          <p className="mb-4" data-id="element-1420">
            Violation of this policy may result in suspension or termination of
            your account.
          </p>
        </section>
        <section className="mb-8" data-id="element-1421">
          <h2 className="text-xl font-semibold mb-4" data-id="element-1422">
            5. Subscriptions, Payments & Refunds
          </h2>
          <ul className="list-disc pl-8 mb-4" data-id="element-1423">
            <li className="mb-2" data-id="element-1424">
              Some Services are free; others require a paid subscription.
            </li>
            <li className="mb-2" data-id="element-1425">
              Subscriptions automatically renew unless canceled before the
              renewal date.
            </li>
            <li className="mb-2" data-id="element-1426">
              Payments are non-refundable, except as required by law.
            </li>
            <li className="mb-2" data-id="element-1427">
              If you cancel, you retain access through the end of the billing
              period.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1428">
          <h2 className="text-xl font-semibold mb-4" data-id="element-1429">
            6. Content Ownership & Rights
          </h2>
          <ul className="list-disc pl-8 mb-4" data-id="element-1430">
            <li className="mb-2" data-id="element-1431">
              You retain ownership of the content you create, submit, or upload
              ("Your Content").
            </li>
            <li className="mb-2" data-id="element-1432">
              By using the Services, you grant FluidForm a non-exclusive,
              worldwide, royalty-free license to host, process, and display Your
              Content solely to operate and improve the Services.
            </li>
            <li className="mb-2" data-id="element-1433">
              FluidForm does not claim ownership of Your Content.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1434">
          <h2 className="text-xl font-semibold mb-4" data-id="element-1435">7. Privacy</h2>
          <p className="mb-4" data-id="element-1436">
            Your use of the Services is governed by our Privacy Policy,
            available at [Privacy Policy URL]. Please review it to understand
            how we collect, use, and share your information.
          </p>
        </section>
        <section className="mb-8" data-id="element-1437">
          <h2 className="text-xl font-semibold mb-4" data-id="element-1438">
            8. Third-Party Integrations
          </h2>
          <p className="mb-4" data-id="element-1439">
            The Services may integrate with third-party platforms (e.g., Slack,
            WhatsApp, CRMs). Your use of those integrations may be subject to
            additional third-party terms. We are not responsible for third-party
            services.
          </p>
        </section>
        <section className="mb-8" data-id="element-1440">
          <h2 className="text-xl font-semibold mb-4" data-id="element-1441">
            9. Service Availability
          </h2>
          <p className="mb-4" data-id="element-1442">
            We aim to keep the Services reliable but cannot guarantee
            uninterrupted or error-free operation. We may modify, suspend, or
            discontinue the Services at any time without liability.
          </p>
        </section>
        <section className="mb-8" data-id="element-1443">
          <h2 className="text-xl font-semibold mb-4" data-id="element-1444">
            10. Warranties & Disclaimers
          </h2>
          <p className="mb-4" data-id="element-1445">
            The Services are provided "as is" without warranties of any kind,
            express or implied. We disclaim all warranties, including
            merchantability, fitness for a particular purpose, and
            non-infringement.
          </p>
        </section>
        <section className="mb-8" data-id="element-1446">
          <h2 className="text-xl font-semibold mb-4" data-id="element-1447">
            11. Limitation of Liability
          </h2>
          <p className="mb-4" data-id="element-1448">
            To the fullest extent permitted by law, FluidForm, its affiliates,
            officers, employees, and agents shall not be liable for indirect,
            incidental, special, consequential, or punitive damages, or for any
            loss of profits, revenues, or data.
          </p>
        </section>
        <section className="mb-8" data-id="element-1449">
          <h2 className="text-xl font-semibold mb-4" data-id="element-1450">
            12. Dispute Resolution & Arbitration
          </h2>
          <p className="mb-4" data-id="element-1451">
            Most disputes can be resolved informally by contacting us at
            support@fluid-form.ai. If a dispute cannot be resolved informally,
            you and FluidForm agree that any claim or controversy arising out of
            or relating to these Terms or the Services will be resolved through
            binding individual arbitration, rather than in court, except that
            you may assert claims in small claims court if they qualify.
          </p>
          <p className="mb-4" data-id="element-1452">
            Arbitration will be conducted by the American Arbitration
            Association (AAA) under its Commercial Arbitration Rules. The
            arbitration shall take place in San Francisco, California, or
            virtually if agreed by both parties.
          </p>
          <p className="mb-4" data-id="element-1453">
            Class Action Waiver: All claims must be brought on an individual
            basis, not as part of a class or representative action.
          </p>
          <p className="mb-4" data-id="element-1454">
            Opt-Out: You may opt out of arbitration within 30 days of first
            accepting these Terms by emailing support@fluid-form.ai with the
            subject line "Arbitration Opt-Out." If you opt out, disputes will be
            resolved in court subject to Section 13 (Governing Law).
          </p>
        </section>
        <section className="mb-8" data-id="element-1455">
          <h2 className="text-xl font-semibold mb-4" data-id="element-1456">13. Governing Law</h2>
          <p className="mb-4" data-id="element-1457">
            These Terms are governed by the laws of the State of Delaware,
            without regard to its conflict of laws principles.
          </p>
        </section>
        <section className="mb-8" data-id="element-1458">
          <h2 className="text-xl font-semibold mb-4" data-id="element-1459">
            14. Changes to These Terms
          </h2>
          <p className="mb-4" data-id="element-1460">
            We may update these Terms from time to time. If we make material
            changes, we will notify you (e.g., via email or notice in the
            Services). Continued use after changes take effect constitutes your
            acceptance.
          </p>
        </section>
        <section className="mb-8" data-id="element-1461">
          <h2 className="text-xl font-semibold mb-4" data-id="element-1462">15. Contact Us</h2>
          <p className="mb-4" data-id="element-1463">
            If you have questions about these Terms, please contact us at:{' '}
            <a href="mailto:support@fluid-form.ai" className="text-blue-600 hover:underline" data-id="element-1464">
              support@fluid-form.ai
            </a>
          </p>
        </section>
      </main>
      <Footer data-id="element-1465" />
    </div>;
};
export default TermsOfUse;